import BeaconReducer from "./Beacon";
import BusinessGroupReducer from "./BusinessGroup";
import CommonReducer from "./Common";
import ModerationReducer from "./Moderation";
import CategoryReducer from "./Category";

const reducers = {
  beacon: BeaconReducer,
  businessGroup: BusinessGroupReducer,
  common: CommonReducer,
  moderation: ModerationReducer,
  category: CategoryReducer
};

export default reducers;
